const optionsDefaults = {
  attributeNames: {
    styleName: 'className',
  },
  generateScopedName: '[path]___[name]__[local]___[hash:base64:5]',
  handleMissingStyleName: 'throw',
};

export default optionsDefaults;
